import { uploadWithProgress } from '@ublend-npm/multipart-uploader';
import { Transforms, Range } from 'slate';
import { ReactEditor } from 'slate-react';
import { insertVoidElement } from './commands';
import { AulaEditorContext, AulaEditorInstance } from '../types';
import { fileBlockType } from '../plugins/file/fileBlockType';

const multipartUpload = async ({
  file,
  context,
  entity,
}: {
  file: File;
  context: Omit<AulaEditorContext, 'entities'>;
  entity: string;
}) => {
  try {
    await uploadWithProgress({
      file,
      uploadUrl: `${context.config.apiUrl}/file/upload`,
      retries: context.config.uploadRetries,
      block: {},
      handleUpload: (uploadEvent) => {
        if (uploadEvent.progress != null) {
          context.updateEntity(entity, { transient: uploadEvent });
        } else {
          context.updateEntity(entity, {
            data: uploadEvent,
            transient: undefined,
          });
        }
      },
    });
  } catch (err) {
    console.error(err);
    context.updateEntity(entity, { failed: true });
  }
};

export const insertAndUpload = ({
  file: _file,
  editor,
  range,
  context,
  isRecording,
}: {
  editor: AulaEditorInstance;
  range: Range;
  file: File;
  context: Omit<AulaEditorContext, 'entities'>;
  isRecording?: boolean;
}) => {
  const entity = context.createEntity({
    type: 'file',
    file: {
      name: _file.name,
      size: _file.size,
      type: _file.type,
      lastModified: _file.lastModified,
      isRecording,
    },
  });

  void multipartUpload({
    file: _file,
    context,
    entity,
  });

  Transforms.splitNodes(editor, { at: range });

  /**
   * Set the editor selection to prevent loss of focus
   * when the block is inserted
   */
  Transforms.select(editor, range);

  insertVoidElement(
    editor,
    {
      type: fileBlockType,
      entity,
    },
    range,
  );

  ReactEditor.focus(editor);
};
